import {
    dateQueryInputAllOption,
    dateQueryInput24HoursOption,
    dateQueryInput3DaysOption,
    dateQueryInput7DaysOption,
    dateQueryInput30DaysOption,
    getDateQueryInputCustomOption,
    dateQueryInputTodayOption,
    dateQueryInputLastMonthOption,
    dateQueryInputLastThreeMonthOption,
    dateQueryInputLastFourMonthsOption,
    dateQueryInputLastWeekOption,
    dateQueryInputThisMonthOption,
    dateQueryInputThisWeekOption,
    dateQueryInputYesterdayOption,
    dateQueryInputLastQuarterOption,
    dateQueryInputLastFourQuartersOption,
    dateQueryInput90DaysRelativeTimezoneOption
} from '../../../Common/Forms/models/date-query-input-options.model';

export const getMonitoringDateQueryInputFolderOptions = () => {
    return [
        dateQueryInputAllOption,
        dateQueryInput24HoursOption,
        dateQueryInput3DaysOption,
        dateQueryInput7DaysOption,
        dateQueryInput30DaysOption,
        dateQueryInput90DaysRelativeTimezoneOption,
        dateQueryInputTodayOption,
        dateQueryInputYesterdayOption,
        dateQueryInputThisWeekOption,
        dateQueryInputLastWeekOption,
        dateQueryInputThisMonthOption,
        dateQueryInputLastMonthOption,
        dateQueryInputLastThreeMonthOption,
        dateQueryInputLastFourMonthsOption,
        dateQueryInputLastQuarterOption,
        dateQueryInputLastFourQuartersOption,
        getDateQueryInputCustomOption()
    ];
};

export const getMonitoringDateQueryInputTagOptions = () => {
    return [
        dateQueryInputAllOption,
        dateQueryInput24HoursOption,
        dateQueryInput3DaysOption,
        dateQueryInput7DaysOption,
        dateQueryInput30DaysOption,
        dateQueryInput90DaysRelativeTimezoneOption,
        dateQueryInputTodayOption,
        dateQueryInputYesterdayOption,
        dateQueryInputThisWeekOption,
        dateQueryInputLastWeekOption,
        dateQueryInputThisMonthOption,
        dateQueryInputLastMonthOption,
        dateQueryInputLastThreeMonthOption,
        getDateQueryInputCustomOption()
    ];
};

export const getMonitoringDateQueryInputTopicOptions = () => {
    return [
        dateQueryInput24HoursOption,
        dateQueryInput3DaysOption,
        dateQueryInput7DaysOption,
        dateQueryInput30DaysOption,
        dateQueryInput90DaysRelativeTimezoneOption,
        dateQueryInputTodayOption,
        dateQueryInputYesterdayOption,
        dateQueryInputThisWeekOption,
        dateQueryInputLastWeekOption,
        dateQueryInputThisMonthOption,
        dateQueryInputLastMonthOption,
        dateQueryInputLastThreeMonthOption,
        dateQueryInputLastFourMonthsOption,
        dateQueryInputLastQuarterOption,
        dateQueryInputLastFourQuartersOption,
        getDateQueryInputCustomOption()
    ];
};

export const monitoringDefaultDateQueryInputTopicOptions = [
    dateQueryInput24HoursOption,
    dateQueryInput3DaysOption,
    dateQueryInput7DaysOption,
    dateQueryInput30DaysOption,
    dateQueryInput90DaysRelativeTimezoneOption
];

export const monitoringDefaultDateTopicOptions = [
    dateQueryInput24HoursOption,
    dateQueryInput3DaysOption,
    dateQueryInput7DaysOption
];


export const getAllDateQueryOptions = () => {
    return [
        dateQueryInputAllOption,
        dateQueryInput24HoursOption,
        dateQueryInput3DaysOption,
        dateQueryInput7DaysOption,
        dateQueryInput30DaysOption,
        dateQueryInput90DaysRelativeTimezoneOption,
        dateQueryInputTodayOption,
        dateQueryInputYesterdayOption,
        dateQueryInputThisWeekOption,
        dateQueryInputLastWeekOption,
        dateQueryInputThisMonthOption,
        dateQueryInputLastMonthOption,
        dateQueryInputLastThreeMonthOption,
        dateQueryInputLastFourMonthsOption,
        dateQueryInputLastQuarterOption,
        dateQueryInputLastFourQuartersOption,
        getDateQueryInputCustomOption()
    ];
};
export const getVIDateQueryInputOptions = () => {
    return [
        dateQueryInput30DaysOption
    ];
};
